import { DashboardPeriodPreset } from "../types/ownerDashboard.types";

export const DEFAULT_CHART_PERIOD: DashboardPeriodPreset = "last_12_months";
export const DEFAULT_VISITS_PERIOD: DashboardPeriodPreset = "last_30_days";
export const DEFAULT_OFFERS_PERIOD: DashboardPeriodPreset = "last_30_days";
export const DEFAULT_PROPERTY_ANALYTICS_PERIOD: DashboardPeriodPreset = "last_30_days";

export const DASHBOARD_PERIOD_PRESETS: DashboardPeriodPreset[] = [
  "last_30_days",
  "last_90_days",
  "last_6_months",
  "last_12_months",
  "current_year",
  "all_time",
];

export const PROPERTY_ANALYTICS_PERIOD_PRESETS: DashboardPeriodPreset[] =
  DASHBOARD_PERIOD_PRESETS;

export const DASHBOARD_PERIOD_LABELS: Record<DashboardPeriodPreset, string> = {
  last_30_days: "Últimos 30 dias",
  last_90_days: "Últimos 90 dias",
  last_6_months: "Últimos 6 meses",
  last_12_months: "Últimos 12 meses",
  current_year: "Ano atual",
  all_time: "Todo o período",
};
